import { render, staticRenderFns } from "./UbicacionesList.vue?vue&type=template&id=16c92276&"
import script from "./UbicacionesList.vue?vue&type=script&lang=js&"
export * from "./UbicacionesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports